import { FETCH_METHODS, SearchConfig } from "../api.model"
import { DataTableSchema, TableColumnSchema } from "../dynamic-data-table.model"
import { CertificationDropdown, DefaultNumber, defaultSearchContainerButtons, EmpStatusDropdown, FieldNames, FirstNameText, LastNameText, SpinIdNumber } from "../form-fields.model";
import { ButtonFieldConfig, DynamicFormArray, FormFieldConfig, Props } from "../form.model"
import { TenureAreaOptions, tenureAreaRegionField, TenureDefaultTableSchema, TenureTitle } from "../tenure.model";

const LexusGrantTenureFilterField: FormFieldConfig = {
  ...structuredClone(DefaultNumber),
  fieldName: FieldNames['Tenure'],
  displayName: 'Lexus Grant Tenure',
  fieldCriteriaConfig: {
    operators: [
      { value: 'less than', label: 'Less than', title: 'Less Than' },
      { value: 'greater than', label: 'Greater than', title: 'Greater Than' },
      { value: 'equal to', label: 'Equal to', title: 'Equal to' }
    ],
    value: 'equal to'
  }
}
const FormFieldArray: FormFieldConfig[] = structuredClone([
  SpinIdNumber,{...structuredClone(tenureAreaRegionField),multiple:true, options:TenureAreaOptions}, FirstNameText, LastNameText, EmpStatusDropdown,
   { ...structuredClone(CertificationDropdown),options:[{ fieldValue: 'M', fieldLabel: 'Master' }, { fieldValue: 'E', fieldLabel: 'Expert' }],multiple:false }, LexusGrantTenureFilterField
]);

const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultSearchContainerButtons);

const columnSchema: Array<TableColumnSchema> = [
  { label: "SPIN ID", fieldKey: 'spinId' },
  { label: "FIRST NAME", fieldKey: 'firstName' },
  { label: "LAST NAME", fieldKey: 'lastName' },
  { label: "EMAIL", fieldKey: 'email' },
  { label: "EMPLOYEE STATUS", fieldKey: 'employeeStatus' },
  { label: "CERTIFICATION", fieldKey: 'certLevel' },
  { label: "CERTIFICATION DATE", fieldKey: 'certDate' },
  { label: "Actual Brand Tenure", fieldKey: 'actualTenure' },
  { label: "Adjusted Lexus Grant Tenure", fieldKey: 'adjustedTenure' , isCamelCaseHeader: true },
  { label: "Total Tenure", fieldKey: 'grantTenure' , isCamelCaseHeader: true }
]


export const LexusGrantTenureTitle = 'Lexus Grant Tenure'

export const LexusGrantTenureSearchConfig: SearchConfig = {
  method: FETCH_METHODS['Post'],
  path: "getLexusGrantTenure",
  body: {
    "spinId": "",
    "area": "",
    "firstName": "",
    "lastName": "",
    "employeeStatus": "",
    "tenureCondition": "",
    "tenure": "",
  }
}

export const LexusGrantTenureFilterSchema: DynamicFormArray = {
  FieldsArray: FormFieldArray,
  ButtonsArray: FormButtonArray,
  searchConfig: LexusGrantTenureSearchConfig,
}

export const LexusGrantTenureTableSchema: DataTableSchema = {
  ...structuredClone(TenureDefaultTableSchema),
  exportConfig:{
    fileName: 'Lexus Grant_Tenure',
    exportMessage:'Lexus Grant Tenure data',
  },
  columnSchema: columnSchema,
  breadcrums: [{ level: 1, name: TenureTitle }, { level: 2, name: LexusGrantTenureTitle }]
}
export const note: Array<any> = [
    'Tenure displayed in Months'
]

export const LexusGrantTenureProps: Props = {
  isBreadCrumbSection: true,
  optionExplanation: note,
}